import { FrameBody,Error,ErrorProps } from "@npd-ng/adp-benchmark";
import errorIcon from '../assets/error_icon.svg';
import { Content } from "../types/Content";
import { useStateContext } from "../hooks/useStateContext";
const logPrefix = "[ADPClient][ErrorView]"
export default function ErrorView() {
  const { state} = useStateContext();
  console.warn(logPrefix, "application error", state.deviceReadinessState.validationError);
  const content= state.staticContent as Content;
  const type = state.deviceReadinessState.validationError || "SystemError";
  const deviceReadiness =content.deviceReadiness[type];
  const actions = content.actions
  const errorProps: ErrorProps = {
    error:{
      iconSrc: errorIcon,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
          label: actions.exit,
          action:()=>{window.close()},
          variant: "secondary"
      }]}
    }
  return (
    <>
       <FrameBody>
          <Error {...errorProps}/>
       </FrameBody>

    </>
  )
}
